import type { RedoListItem } from "../../arbiter-components/list/redo-list";
import type { ArrayStringTableFilter } from "../advanced-filter";

// No React component imports here — kept dependency-free so it's unit
// testable without the @mui/material deep-import chain Jest can't parse.
export function buildShortcutStaticItems(
  shortcuts: ArrayStringTableFilter["shortcuts"],
): RedoListItem<void>[] {
  if (!shortcuts || shortcuts.length === 0) {
    return [];
  }
  return shortcuts.map<RedoListItem<void>>((shortcut) => ({
    id: `shortcut-${shortcut.id}`,
    value: undefined as void,
    type: "text",
    text: shortcut.label,
  }));
}

export function applyShortcutToggle(
  currentValues: string[],
  shortcut: { id: string; label: string; values: string[] },
): string[] {
  const currentSet = new Set(currentValues);
  const allSelected = shortcut.values.every((v) => currentSet.has(v));
  return allSelected
    ? currentValues.filter((v) => !shortcut.values.includes(v))
    : [...new Set([...currentValues, ...shortcut.values])];
}
